const minin = {
  data() {
    return {
      istime: false,
      form: {
        istime: '2',
        inton: undefined,
        unton: undefined,
      },
      // 基础信息
      formCtrl: [],
      // 普通订单基础信息
      formCtrlNo: [
        {
          label: "订单编号",
          keyName: "order_num",
          err: "请填写订单编号",
          type: "text",
          viewMode: true,
        },
        {
          label: "客户名称",
          keyName: "shname",
          err: "请填写客户名称",
          type: "text",
          viewMode: true,
        },
        {
          label: "联系方式",
          keyName: "shtel",
          err: "请填写联系方式",
          type: "text",
          viewMode: true,
        },
        {
          label: "信息费",
          keyName: "message",
          err: "请填写信息费",
          type: "text",
          viewMode: true,
        },
        {
          label: "货物名称",
          keyName: "name",
          err: "请填写货物名称",
          type: "text",
          viewMode: true,
        },
      ],
      // 装货信息
      formCtrlIn: [
        {
          label: "装货地址",
          keyName: "coaddress",
          err: "请填写装货地址",
          type: "text",
          viewMode: true,
        },
        {
          label: "装货联系人",
          keyName: "drman",
          err: "请填写装货联系人",
          type: "text",
          viewMode: true,
        },
        {
          label: "联系方式",
          keyName: "drtel",
          err: "请填写联系方式",
          type: "text",
          viewMode: true,
        },
        {
          label: "装货日期",
          keyName: "starttime",
          err: "请填写装货日期",
          type: "text",
          viewMode: true,
        },
      ],
      // 卸货信息
      formCtrlOut: [
        {
          label: "卸货地址",
          keyName: "enaddress",
          err: "请填写卸货地址",
          type: "text",
          viewMode: true,
        },
        {
          label: "卸货联系人",
          keyName: "enman",
          err: "请填写卸货联系人",
          type: "text",
          viewMode: true,
        },
        {
          label: "联系方式",
          keyName: "ertel",
          err: "请填写联系方式",
          type: "text",
          viewMode: true,
        },
      ],
      // 运单信息
      formCtrlOrder: [
        {
          label: "公司单价（元/吨）",
          keyName: "cprice",
          err: "请填写公司单价",
          type: "number",
          viewMode: true,
        },
        {
          label: "司机单价（元/吨）",
          keyName: "dprice",
          err: "请填写司机单价",
          type: "number",
          viewMode: true,
        },
        {
          label: "车牌号",
          keyName: "license",
          err: "请填写车牌号",
          type: "text",
          viewMode: true,
        },
        {
          label: "装货重量（吨）",
          keyName: "inton",
          err: "请填写装货重量",
          type: "text",
        },
        {
          label: "卸货重量（吨）",
          keyName: "unton",
          err: "请填写卸货重量",
          type: "text",
          className: "unton",
        },
        {
          label: "装货单",
          keyName: "invoice",
          err: "请填写装货单",
          type: "file",
          tips: "图片大小最好不要超过2M",
          // viewMode: true,
        },
        {
          label: "卸货单",
          keyName: "uninvoice",
          err: "请填写卸货单",
          type: "file",
          tips: "图片大小最好不要超过2M",
          // viewMode: true,
          className: "unton",
        },
        {
          label: "计算重量（吨）",
          keyName: "caton",
          err: "请填写计算重量",
          type: "text",
          tips: "不填写则默认卸货重量为计算重量！",
        },
        {
          label: "亏吨重量（吨）",
          keyName: "kuiton",
          err: "请填写亏吨重量",
          type: "text",
          viewMode: true,
        },
        {
          label: "公司承担亏吨重量（吨）",
          keyName: "ceton",
          err: "请填写公司承担亏吨重量",
          type: "number",
          tips: "不填写则默认亏吨重量为计算重量！",
        },
        {
          label: "亏吨单价（元/吨）",
          keyName: "dtonprice",
          err: "请填写亏吨单价",
          type: "number",
          tips: "不填写则默认亏吨的钱不算到运费！",
        },
        // {
        //   label: "实际公司承担亏吨",
        //   keyName: "dceton",
        //   err: "请填写实际公司承担亏吨",
        //   type: "number",
        //   tips: "不填写无法计算出实际运费！",
        // },
        // {
        //   label: "实际亏吨单价（元/吨）",
        //   keyName: "dtonprices",
        //   err: "请填写实际亏吨单价",
        //   type: "number",
        //   tips: "不填写无法计算出实际运费！",
        // },
      ],
      // 预计结款日期
      formCtrl2: [
        {
          label: "预计结款日期",
          keyName: "repaytime",
          err: "请填写预计结款日期",
          type: "date",
          tips: "不填写则默认没有预计结款日期！",
          className: "block",
        },
        // {
        //   label: "结款提醒",
        //   keyName: "istime",
        //   type: "radio",
        //   options: [
        //     { label: '开启', value: '1' },
        //     { label: '关闭', value: '2' },
        //   ],
        // },
      ],
    };
  },
  methods: {
    updateStatus() {
      this.$confirm('确认审核通过吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.updateStatusReq();
      }).catch(() => { });
    },
    updateStatusReq() {
      this.loading = true
      let url = `${this.baseUrl}/updatestatus`;
      const params = {
        userid: this.user.id,
        id: this.id,
        isstatus: 4,
      }

      const mod = this.$route.path.includes('/nocontract') ? 'order' : 'contract_order'
      params['headers'] = {
        'X-Method': 'review',
        'X-Module': mod,
      }

      // console.log(url, params)

      this.post(url, params, ({ msg }) => {
        this.loading = false
        if (msg == 'success') {
          this.$message({
            type: 'success',
            message: '审核通过成功!',
          });
          this.$router.back()
        } else {
          this.$message({
            type: 'error',
            message: msg
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '审核通过失败，请稍后重试！'
        });
      })
    },
    checkInTon(rule, value, callback) {
      // console.log(rule, value)
      // console.log(Number(value))
      // console.log(Number(value) > 60)
      if (value == undefined || value == '') {
        callback(new Error('请填写装货重量'));
      } else if (Number(value) > 60) {
        callback(new Error('重量不能超过60吨'));
      } else {
        callback();
      }
    },
    checkUnTon(rule, value, callback) {
      // console.log(rule, value)
      // console.log(Number(value))
      // console.log(Number(value) > 60)
      if (value == undefined || value == '') {
        callback(new Error('请填写卸货重量'));
      } else if (Number(value) > 60) {
        callback(new Error('重量不能超过60吨'));
      } else {
        callback();
      }
    },
    setDetail() {
      const formCtrl = [...this.formCtrlNo]
      const In = this.formCtrlIn
      if (In && In.length) {
        formCtrl.push(...In)
      }
      const Out = this.formCtrlOut
      if (Out && Out.length) {
        formCtrl.push(...Out)
      }
      const Order = this.formCtrlOrder
      if (Order && Order.length) {
        formCtrl.push(...Order)
      }
      const f2 = this.formCtrl2
      if (f2 && f2.length) {
        formCtrl.push(...f2)
      }
      this.detailHandler(formCtrl)
    },
    toggleSwitch() {
      this.istime ? (this.form['istime'] = 1) : (this.form['istime'] = 2)
    },
    detailHandler(formCtrl) {
      formCtrl.map(v => {
        const key = v.keyName
        // console.log(key)
        // if (['shname'].includes(key) && this.detail['shtel']) {
        //   this.form[key] = `${this.detail[key]}:${this.detail['shtel']}`;
        // } else if (['drman'].includes(key) && this.detail['drtel']) {
        //   this.form[key] = `${this.detail[key]}:${this.detail['drtel']}`;
        // } else if (['enman'].includes(key) && this.detail['ertel']) {
        //   this.form[key] = `${this.detail[key]}:${this.detail['ertel']}`;
        // } else
        // console.log(v)
        if (['kuiton'].includes(key) && v.viewMode) {
          this.form[key] = `${this.detail[key]}吨`;
        } else if (['message'].includes(key) && v.viewMode) {
          // console.log(v)
          this.form[key] = `${this.detail[key]}元`;
        } else {
          this.form[key] = this.detail[key];
        }
      })
      if (this.form['repaytime']) {
        this.form.istime = 1
        this.istime = true
      }
      // 货物id，提交时需要回传
      this.form['nid'] = this.detail['nid'];
      this.form['id'] = this.detail['id'];
      this.$forceUpdate()
      // console.log({ ...this.detail })
      // console.log({ ...this.form })
    },
    paramsPackage(params, object) {
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          // console.log(key, object[key], typeof object[key])
          const value = object[key]
          // console.log(value)
          if (value && typeof value === 'object') {
            console.log(key, value)
            params[key] = value.map(v => {
              let result = v
              if (v.response && v.response.photo) {
                result = { url: v.response.photo }
              }
              return result
            })
          } else if (typeof value === 'string' && value.includes('元')) {
            params[key] = value.replace('元', '')
          } else {
            params[key] = value;
          }
        }
      }
      const opt = this.id ? 'update' : 'create'
      console.log(opt)
      params['headers'] = {
        'X-Method': opt,
        'X-Module': 'order',
      }
      // console.log('params', { ...params })
    },
    onChange({ key, value }) {
      // console.log(key, value)
      // console.log(Number(value))
      if (['invoice', 'uninvoice'].includes(key) && value.length == 1 && value[0] && value[0].response) {
        this.form[key] = value[0].response.photo
        // console.log(this.form[key])
      } else if (['identitycard', 'driverslicense', 'certificate', 'escortcard'].includes(key) || key.includes('photo') || (value && typeof value === 'object')) {
        this.form[key] = value.map(v => {
          let result = v
          if (v.response && v.response.photo) {
            result = { url: v.response.photo }
          }
          return result
        })
      } else {
        this.form[key] = value;
      }
      console.log({ ...this.form });
    },
  },
}

export default minin